export const ELEMENT_PANEL_FOLDER = {
  COMPLETION: "Completion",
  ACTIONS: "Actions",
  COUNTS_AND_SCORES: "Counts & Scores",
  FOLDERS: "Folders",
};
